import { ImportedListing } from '../../_types/imported-listing'
import { ListingsQuestionConfidence } from '../../_types/quickpass-llm'
import { CompactListingForQuestion } from './types'

const DESCRIPTION_EXCERPT_MAX = 280
const MAX_LISTINGS_IN_PROMPT = 30

const compactListing = (
  listing: ImportedListing,
): CompactListingForQuestion => {
  const trimmedDescription = listing.description
    .replace(/\s+/gu, ' ')
    .trim()
    .slice(0, DESCRIPTION_EXCERPT_MAX)

  return {
    id: listing.id,
    title: listing.title,
    priceMonthly: listing.priceMonthly,
    bedrooms: listing.bedrooms,
    bathrooms: listing.bathrooms,
    propertyType: listing.propertyType,
    city: listing.city,
    fullAddress: listing.fullAddress,
    isAvailable: listing.isAvailable,
    descriptionExcerpt: trimmedDescription,
  }
}

/**
 * Builds a compact projection of the renter's tracked listings for the
 * listings-question LLM prompt. Caps the volume to keep tokens bounded
 * and strips fields that would just bloat the prompt without helping
 * the answer.
 *
 * @param {ImportedListing[]} listings - the renter's tracked listings
 * @returns {CompactListingForQuestion[]} the trimmed projection
 */
const buildCompactListingsForPrompt = (
  listings: ImportedListing[],
): CompactListingForQuestion[] => {
  return listings.slice(0, MAX_LISTINGS_IN_PROMPT).map(compactListing)
}

const SUGGESTION_PROMPTS: string[] = [
  'Which ones have parking?',
  'Cheapest 2-bedroom?',
  'Anything pet friendly?',
  'Closest to downtown?',
  'Best deal on price per bedroom?',
]

const confidenceLabel = (confidence: ListingsQuestionConfidence): string => {
  if (confidence === 'high') {
    return 'Confident'
  }
  if (confidence === 'medium') {
    return 'Best guess'
  }
  return 'Low confidence'
}

export { buildCompactListingsForPrompt, SUGGESTION_PROMPTS, confidenceLabel }
